/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { KeysOf } from "#app/composables/asyncData";
import { isMocked, mockPath } from "#root/api/util/mocking";
import type { ApiOptions, UseApiOptions } from "../http-client";
import { HttpClient } from "../http-client";
import type {
  GetFavoritesData,
  GetSavedForLaterData,
  GetSharedFavoritesData,
  RemoveFavoritesItemData,
  WishlistsAddToFavoritesData,
  WishlistsFavoritesItemRequest,
  WishlistsShareFavoritesData,
  WishlistsShareFavoritesPayload,
} from "./data-contracts";

export class Wishlists extends HttpClient {
  static paths = {
    getFavorites: "/wishlists/v2/favorites",
    wishlistsAddToFavorites: "/wishlists/v2/favorites",
    getSavedForLater: "/wishlists/v2/saveForLater",
    getSharedFavorites: "/wishlists/v2/favorites/:favoriteId/share",
    wishlistsShareFavorites: "/wishlists/v2/favorites/:favoriteId/share",
    removeFavoritesItem: "/wishlists/v2/favorites/:favoriteId/items/:itemId",
  };
  static mockDataPaths = {};
  static mockedPaths = {
    getFavorites: false,
    wishlistsAddToFavorites: false,
    getSavedForLater: false,
    getSharedFavorites: false,
    wishlistsShareFavorites: false,
    removeFavoritesItem: false,
  };
  static onResponseHandlers = {};
  constructor(baseParams) {
    super(baseParams, "Api");
  }

  /**
   * No description
   *
   * @tags Wishlists
   * @name GetFavorites
   * @summary Get Favorites API
   * @request GET:/wishlists/v2/favorites
   */
  getFavorites = <
    ResT = GetFavoritesData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/wishlists/v2/favorites")
        ? computed(() => mockPath("Wishlists", "getFavorites", ``))
        : computed(() => `/wishlists/v2/favorites`),
      method: "GET",
      format: "json",
      key: `/wishlists/v2/favorites`,
      apiName: "Wishlists.getFavorites",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name GetFavorites
   * @summary Get Favorites API
   * @request GET:/wishlists/v2/favorites
   */
  $getFavorites = (requestParams: ApiOptions = {}) =>
    this.$request<GetFavoritesData>({
      path: isMocked("/wishlists/v2/favorites")
        ? mockPath("Wishlists", "getFavorites", ``)
        : `/wishlists/v2/favorites`,
      method: "GET",
      format: "json",
      apiName: "Wishlists.getFavorites",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name WishlistsAddToFavorites
   * @summary Add to Favorites API
   * @request POST:/wishlists/v2/favorites
   */
  wishlistsAddToFavorites = <
    ResT = WishlistsAddToFavoritesData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: WishlistsFavoritesItemRequest,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/wishlists/v2/favorites")
        ? computed(() => mockPath("Wishlists", "wishlistsAddToFavorites", ``))
        : computed(() => `/wishlists/v2/favorites`),
      method: "POST",
      body: data,
      format: "json",
      key: `/wishlists/v2/favorites`,
      apiName: "Wishlists.wishlistsAddToFavorites",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name WishlistsAddToFavorites
   * @summary Add to Favorites API
   * @request POST:/wishlists/v2/favorites
   */
  $wishlistsAddToFavorites = (
    data: WishlistsFavoritesItemRequest,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<WishlistsAddToFavoritesData>({
      path: isMocked("/wishlists/v2/favorites")
        ? mockPath("Wishlists", "wishlistsAddToFavorites", ``)
        : `/wishlists/v2/favorites`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Wishlists.wishlistsAddToFavorites",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name GetSavedForLater
   * @summary Get Saved for Later
   * @request GET:/wishlists/v2/saveForLater
   */
  getSavedForLater = <
    ResT = GetSavedForLaterData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/wishlists/v2/saveForLater")
        ? computed(() => mockPath("Wishlists", "getSavedForLater", ``))
        : computed(() => `/wishlists/v2/saveForLater`),
      method: "GET",
      format: "json",
      key: `/wishlists/v2/saveForLater`,
      apiName: "Wishlists.getSavedForLater",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name GetSavedForLater
   * @summary Get Saved for Later
   * @request GET:/wishlists/v2/saveForLater
   */
  $getSavedForLater = (requestParams: ApiOptions = {}) =>
    this.$request<GetSavedForLaterData>({
      path: isMocked("/wishlists/v2/saveForLater")
        ? mockPath("Wishlists", "getSavedForLater", ``)
        : `/wishlists/v2/saveForLater`,
      method: "GET",
      format: "json",
      apiName: "Wishlists.getSavedForLater",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name GetSharedFavorites
   * @summary Get Shared Favorites API
   * @request GET:/wishlists/v2/favorites/{favoriteId}/share
   */
  getSharedFavorites = <
    ResT = GetSharedFavoritesData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    favoriteId: MaybeRefOrGetter<string>,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/wishlists/v2/favorites/:favoriteId/share")
        ? computed(() =>
            mockPath(
              "Wishlists",
              "getSharedFavorites",
              `favoriteId:${toValue(favoriteId)}`,
            ),
          )
        : computed(
            () => `/wishlists/v2/favorites/${toValue(favoriteId)}/share`,
          ),
      method: "GET",
      format: "json",
      key: `/wishlists/v2/favorites/${toValue(favoriteId)}/share`,
      apiName: "Wishlists.getSharedFavorites",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name GetSharedFavorites
   * @summary Get Shared Favorites API
   * @request GET:/wishlists/v2/favorites/{favoriteId}/share
   */
  $getSharedFavorites = (favoriteId: string, requestParams: ApiOptions = {}) =>
    this.$request<GetSharedFavoritesData>({
      path: isMocked("/wishlists/v2/favorites/:favoriteId/share")
        ? mockPath(
            "Wishlists",
            "getSharedFavorites",
            `favoriteId:${toValue(favoriteId)}`,
          )
        : `/wishlists/v2/favorites/${favoriteId}/share`,
      method: "GET",
      format: "json",
      apiName: "Wishlists.getSharedFavorites",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name WishlistsShareFavorites
   * @summary Share Favorites API
   * @request POST:/wishlists/v2/favorites/{favoriteId}/share
   */
  wishlistsShareFavorites = <
    ResT = WishlistsShareFavoritesData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    favoriteId: MaybeRefOrGetter<string>,
    data?: WishlistsShareFavoritesPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/wishlists/v2/favorites/:favoriteId/share")
        ? computed(() =>
            mockPath(
              "Wishlists",
              "wishlistsShareFavorites",
              `favoriteId:${toValue(favoriteId)}`,
            ),
          )
        : computed(
            () => `/wishlists/v2/favorites/${toValue(favoriteId)}/share`,
          ),
      method: "POST",
      body: data,
      format: "json",
      key: `/wishlists/v2/favorites/${toValue(favoriteId)}/share`,
      apiName: "Wishlists.wishlistsShareFavorites",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name WishlistsShareFavorites
   * @summary Share Favorites API
   * @request POST:/wishlists/v2/favorites/{favoriteId}/share
   */
  $wishlistsShareFavorites = (
    favoriteId: string,
    data?: WishlistsShareFavoritesPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<WishlistsShareFavoritesData>({
      path: isMocked("/wishlists/v2/favorites/:favoriteId/share")
        ? mockPath(
            "Wishlists",
            "wishlistsShareFavorites",
            `favoriteId:${toValue(favoriteId)}`,
          )
        : `/wishlists/v2/favorites/${favoriteId}/share`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Wishlists.wishlistsShareFavorites",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name RemoveFavoritesItem
   * @summary Remove Favorites Item API
   * @request DELETE:/wishlists/v2/favorites/{favoriteId}/items/{itemId}
   */
  removeFavoritesItem = <
    ResT = RemoveFavoritesItemData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    favoriteId: MaybeRefOrGetter<string>,
    itemId: MaybeRefOrGetter<string>,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/wishlists/v2/favorites/:favoriteId/items/:itemId")
        ? computed(() =>
            mockPath(
              "Wishlists",
              "removeFavoritesItem",
              `favoriteId:${toValue(favoriteId)}.itemId:${toValue(itemId)}`,
            ),
          )
        : computed(
            () =>
              `/wishlists/v2/favorites/${toValue(favoriteId)}/items/${toValue(itemId)}`,
          ),
      method: "DELETE",
      format: "json",
      key: `/wishlists/v2/favorites/${toValue(favoriteId)}/items/${toValue(itemId)}`,
      apiName: "Wishlists.removeFavoritesItem",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Wishlists
   * @name RemoveFavoritesItem
   * @summary Remove Favorites Item API
   * @request DELETE:/wishlists/v2/favorites/{favoriteId}/items/{itemId}
   */
  $removeFavoritesItem = (
    favoriteId: string,
    itemId: string,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<RemoveFavoritesItemData>({
      path: isMocked("/wishlists/v2/favorites/:favoriteId/items/:itemId")
        ? mockPath(
            "Wishlists",
            "removeFavoritesItem",
            `favoriteId:${toValue(favoriteId)}.itemId:${toValue(itemId)}`,
          )
        : `/wishlists/v2/favorites/${favoriteId}/items/${itemId}`,
      method: "DELETE",
      format: "json",
      apiName: "Wishlists.removeFavoritesItem",
      mobileAppTracking: "false",
      ...requestParams,
    });
}
